<template>
  <Row style="padding: 20px">
    <Col span="24">
      <Select
        v-model="params.status"
        placeholder="请选择状态"
        class="public-inp"
      >
        <Option value="">全部</Option>
        <Option value="02">已上架</Option>
        <Option value="03">已下架</Option>
      </Select>
      <Select
        v-model="params.skuCode"
        placeholder="请选择sku"
        class="public-inp"
      >
        <Option value="">全部</Option>
        <Option
          v-for="item in SKUList.data || []"
          :key="item.code"
          :value="item.code"
          >{{ item.name || "" }}</Option
        >
      </Select>
      <Select
        v-model="params.wmsCode"
        placeholder="请输入仓库名称"
        filterable
        clearable
        :remote-method="handleCreate1"
        @on-select="handleCreate2"
        :loading="wmsCodeLoading"
        class="public-inp"
      >
        <Option
          v-for="(option, i) in wmsCodeList"
          :value="option.wmsCode"
          :key="i"
          >{{ option.wmsName }}</Option
        >
      </Select>
      <Select
        v-model="params.areaCode"
        placeholder="请选择省份"
        class="public-inp"
      >
        <Option value="">全部</Option>
        <Option v-for="(item, i) in province" :key="i" :value="item.code">{{
          item.name
        }}</Option>
      </Select>
      <Select
        v-model="params.spCode"
        placeholder="请选择资金商"
        class="public-inp"
      >
        <Option value="">全部</Option>
        <Option
          v-for="item in spInfoQueryAll || []"
          :key="item.code"
          :value="item.code"
          >{{ item.name }}</Option
        >
      </Select>
      <Select
        v-model="params.gradeGroup"
        placeholder="请选择渠道"
        class="public-inp"
      >
        <Option value="">全部</Option>
        <Option
          v-for="(item, index) in baseChannelList || []"
          :key="index"
          :value="item"
          >{{ item }}</Option
        >
      </Select>
      <Input
        class="public-inp"
        v-model="params.spErpCode"
        placeholder="请输入送达方编码"
      />
      <Input
        class="public-inp"
        v-model="params.spErpCode"
        placeholder="请输入资金商商品编码"
      />
      <Button
        type="primary"
        icon="md-search"
        @click="getList"
        v-access="'warehouseProduct.query'"
        >搜索</Button
      >
      <Button @click="resetList" v-access="'warehouseProduct.reset'"
        >重置</Button
      >
      <Button type="primary" @click="getList">批量导入</Button>
    </Col>
    <Col span="24">
      <Table
        :style="{ marginTop: '10px' }"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="wmsInvList"
      >
        <template slot-scope="{ row, index }" slot="sort">
          <span v-show="false">{{ row.code }}</span>
          {{ index + 1 }}
        </template>
        <!-- <template slot-scope="{ row }" slot="action">
          <InputNumber
            :max="999999999"
            :min="0"
            :value="row.sub"
            placeholder="请输入"
            @on-change="(e) => calculation(e, row)"
          ></InputNumber>
        </template> -->
        <template slot-scope="{ row }" slot="status">
          <div style="margin: 0 auto; text-align: center">
            <Button
              v-access="'warehouseProduct.status'"
              type="success"
              size="small"
              v-if="row.status == '02'"
              @click="toggleStatus('0', row)"
              >已上架</Button
            >
            <Button
              v-access="'warehouseProduct.status'"
              type="default"
              size="small"
              v-if="row.status == '03'"
              @click="toggleStatus('1', row)"
              >已下架</Button
            >
          </div>
        </template>
        <template slot-scope="{ row }" slot="history">
          <!-- <Button
            icon="md-repeat"
            size="small"
            type="default"
            @click="logHandler(row)"
            >修改记录</Button
          > -->
          <Button
            size="small"
            type="primary"
            @click="logHandler(row)"
            v-access="'warehouseProduct.details'"
            >查看</Button
          >
        </template>
      </Table>
      <Page
        :total="total"
        :page-size="params.pageSize"
        :current="params.page"
        show-sizer
        show-total
        prev-text="上一页"
        next-text="下一页"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
        class="public-page"
      />
    </Col>
  </Row>
</template>
<script>
const columns = [
  {
    title: "序号",
    slot: "sort",
    width: 60,
  },
  {
    title: "服务商",
    key: "spName",
  },
  {
    title: "商品名称",
    key: "skuName",
  },
  {
    title: "简称",
    key: "erpCode",
  },
  {
    title: "仓库",
    key: "wmsName",
  },
  {
    title: "仓库三方编码",
    key: "thirdPartyCode",
  },
  {
    title: "省份",
    key: "provinceAreaName",
  },
  {
    title: "GRADE GROUP",
    key: "gradeGroup",
  },
  {
    title: "达能系统商品编码",
    key: "prdCode",
  },
  {
    title: "资金商商品编码",
    key: "spErpCode",
  },
  {
    title: "现有库存",
    key: "skuNum",
  },
  //   {
  //     title: "损益数量",
  //     key: "count",
  //   },
  {
    title: "状态",
    slot: "status",
    width: 100,
  },
  {
    title: "操作",
    slot: "history",
    width: 100,
  },
];
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      wmsCodeList: [],
      params: {
        areaCode: "",
        shipToCode: "",
        gradeGroup: "",
        skuCode: "",
        spCode: "",
        wmsCode: "",
        spErpCode: "",
        status: "",
        pageSize: 10,
        page: 1,
      },
      columns,
      total: 0,
      wmsInvList: [],
    };
  },
  computed: {
    ...mapGetters({
      province: "base/getBaseAreaAll",
      SKUList: "stageInfo/getSKUList",
      spInfoQueryAll: "merchant/getSpInfoQueryAll",
      baseChannelList: "warehouse/getWmsBaseChannelList",
    }),
  },
  created() {
    this.getList();
    // 查询所有仓库
    this.handleCreate1("");
    // 查询所有省份
    this.$store.dispatch("base/getBaseAreaAll");
    // 查询所有SKU
    this.$store.dispatch("stageInfo/getSKUList", {
      pageSize: 100,
    });
    // 查询资金商&服务商
    this.$store.dispatch("merchant/getSpInfoQueryAll");
    //查询渠道列表
    this.$store.dispatch("warehouse/getWmsBaseChannelList");
  },
  methods: {
    getList() {
      this.loading = true;
      this.$api.searchInvList(this.params).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.wmsInvList = res.data;
          this.total = res.total;
        }
      });
    },
    calculation(e, r) {
      this.tbList = this.tbList.map((item, i) => {
        if (item.id == r.id) {
          item.sub = e;
          item.sum = e == null ? null : e - item.skuNum;
        }
        return item;
      });
    },
    action(t) {
      switch (t) {
        case 1:
          this.saveList();
          break;
        case 2:
          this.page = 1;
          this.pageSize = 10;
          this.$nextTick(() => {
            this.getList();
          });
          break;
        default:
          this.$router.replace({ path: "/inventory" });
      }
    },
    // 重置
    resetList() {
      this.params.areaCode = "";
      this.params.shipToCode = "";
      this.params.gradeGroup = "";
      this.params.skuCode = "";
      this.params.spCode = "";
      this.params.wmsCode = "";
      this.params.spErpCode = "";
      this.params.status = "";
      // 分页数据
      this.params.page = 1;
      this.params.pageSize = 10;

      this.getList();
    },
    // 页码
    pageChange(d) {
      this.params.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.params.pageSize = d;
      this.getList();
    },
    logHandler(row) {
      // return
      this.$router.push({
        path: "/inventoryLogByProduct",
        query: {
          skuCode: row.skuCode || "",
          skuName: row.skuName || "",
          spCode: row.spCode || "",
          gradeGroup: row.gradeGroup || "",
          wmsCode: row.wmsCode || "",
          areaCode: row.provinceAreaCode || "",
          wmsName: row.wmsName || "",
          // 新增传值字段
          spName: row.spName,
          spCode: row.spCode,
          skuNum: row.skuNum,
          status: row.status,
        },
      });
    },
    handleCreate1(val) {
      let data = { name: val };
      this.wmsCodeLoading = true;
      this.$api.wareVagueSearch(data).then((res) => {
        this.wmsCodeLoading = false;
        if (res.code == "200") {
          this.wmsCodeList = res.data;
        }
      });
    },
    handleCreate2(code) {
      this.wmsCodeList.forEach((item) => {
        if (item.wmsCode == code) {
          this.params.wmsCode = code;
        }
      });
    },
    toggleStatus(type, row) {
      let content = type == 0 ? "确定下架吗" : "确定上架吗";
      this.$Modal.confirm({
        title: "提示",
        content: content,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          if (type == 0) {
            this.$store
              .dispatch("warehouse/wmsInvDisable", { id: row.id })
              .then((res) => {
                if (res.code == "200") {
                  this.$Message.success("下架成功");
                  this.getList();
                } else {
                  this.$Message.error(res.msg || "下架失败");
                }
              });
          } else {
            this.$store
              .dispatch("warehouse/wmsInvEnable", { id: row.id })
              .then((res) => {
                if (res.code == "200") {
                  this.$Message.success("上架成功");
                  this.getList();
                } else {
                  this.$Message.error(res.msg || "上架失败");
                }
              });
          }
        },
      });
    },
  },
};
</script>
<style scoped>
.ivu-table-border th {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/warehouse/warehouseProduct.vue